import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12 pt-5 pt-md-5"
}
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "d-none d-md-block col-12 justify-content-between" }
const _hoisted_4 = { class: "title-3 text-grey-900 pt-2 pb-4" }
const _hoisted_5 = {
  class: "d-md-none col-12 w-100 border-1 py-2 py-lg-3",
  "data-toggle": "collapse",
  type: "button",
  "data-target": "#tf-info-domain-conencted-inner",
  "aria-expanded": "false",
  "aria-controls": "tf-info-domain-conencted-inner"
}
const _hoisted_6 = { class: "d-flex justify-content-between border-top border-gray py-2" }
const _hoisted_7 = { class: "title-3 text-grey-900 pt-2" }
const _hoisted_8 = {
  "data-mobile-collapsed": "",
  "data-desktop-expanded": "",
  class: "collapse",
  id: "tf-info-domain-conencted-inner"
}
const _hoisted_9 = { class: "d-flex flex-column flex-md-row nowrap row" }
const _hoisted_10 = { class: "col-12 col-md-5 justify-content-between" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "link-large-underline link-default read-more py-3 cursor-pointer" }
const _hoisted_13 = { class: "link-large-underline link-default read-less cursor-pointer" }
const _hoisted_14 = { class: "pr-1" }
const _hoisted_15 = { class: "col-12 col-lg-7" }

import { ref, onMounted } from "vue";
import TextShowMoreLess from "@/textShowMoreLess/textShowMoreLess.js";
import SkiAreaStats from "./SkiAreaStats.vue";
import SlopesInformation from "./SlopesInformation.vue";

interface ConnectedDomainSectionProps {
  data: Record<string, any>;
  stationData: Record<string, any>;
  season: string;
  content: Record<string, string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectedDomainInfo',
  props: {
    data: {},
    stationData: {},
    season: {},
    content: {}
  },
  setup(__props: any) {

const props = __props;
const connectedDomainDescriptionWrap = ref<HTMLElement | null>(null);

const initializeTextShowMoreLess = () => {
  if (connectedDomainDescriptionWrap.value) {
    const textShowMoreLess = new TextShowMoreLess(connectedDomainDescriptionWrap.value, 15);
    textShowMoreLess.init();
  }
};

onMounted(() => {
  initializeTextShowMoreLess();
});

return (_ctx: any,_cache: any) => {
  return (_ctx.season === 'H' && _ctx.stationData.connectedNameDomain && _ctx.stationData.connectedDomainDescription)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.season === 'H')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.content.station_ConnectedDomain) + " " + _toDisplayString(_ctx.stationData.connectedNameDomain), 1)
              ]),
              _createElementVNode("a", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.content.station_ConnectedDomain) + " " + _toDisplayString(_ctx.stationData.connectedNameDomain), 1),
                  _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex d-sm-none align-items-center text-light-blue\"><svg color=\"black\" width=\"13\" height=\"13\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-up\" fill=\"none\"><use xlink:href=\"#___icon___chevron-up-bold\"></use></svg><svg color=\"black\" width=\"13\" height=\"13\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"none\"><use xlink:href=\"#___icon___chevron-down-bold\"></use></svg></div>", 1))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      id: "connectedDomainDescription",
                      ref_key: "connectedDomainDescriptionWrap",
                      ref: connectedDomainDescriptionWrap,
                      class: "body text-grey-900 pt-4"
                    }, [
                      _createElementVNode("div", {
                        class: "body text-grey-900 show-more-less-text mb-0 mb-md-2",
                        innerHTML: _ctx.stationData.connectedDomainDescription
                      }, null, 8, _hoisted_11),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.content.station_seeMore), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("span", null, [
                          _createElementVNode("svg", {
                            color: "#0042b8",
                            width: "10",
                            height: "10"
                          }, [
                            _createElementVNode("use", { "xlink:href": "#___icon___chevron-right-bold" })
                          ])
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", null, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.content.station_seeLess), 1),
                          _cache[2] || (_cache[2] = _createElementVNode("span", null, [
                            _createElementVNode("svg", {
                              color: "#0042b8",
                              width: "10",
                              height: "10"
                            }, [
                              _createElementVNode("use", { "xlink:href": "#___icon___chevron-up-bold" })
                            ])
                          ], -1))
                        ])
                      ])
                    ], 512)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(SkiAreaStats, {
                      pisteLength: _ctx.stationData.domaineReliePistLength,
                      nbSlopes: _ctx.stationData.connectedDomainNbSlopes,
                      nbSkiLifts: _ctx.stationData.nbConnectedDomainSkiLifts,
                      data: _ctx.data,
                      stationData: _ctx.stationData,
                      content: _ctx.content,
                      isConnectedDomain: true
                    }, null, 8, ["pisteLength", "nbSlopes", "nbSkiLifts", "data", "stationData", "content"]),
                    (_ctx.stationData.nbSlopesGreen)
                      ? (_openBlock(), _createBlock(SlopesInformation, {
                          key: 0,
                          nbSlopesGreen: _ctx.stationData.connectedDomainNbSlopesGreen,
                          nbSlopesBlue: _ctx.stationData.connectedDomainNbSlopesBlue,
                          nbSlopesRed: _ctx.stationData.connectedDomainNbSlopesRed,
                          nbSlopesBlack: _ctx.stationData.connectedDomainNbSlopesBlack,
                          domainName: _ctx.stationData.connectedNameDomain,
                          content: _ctx.content
                        }, null, 8, ["nbSlopesGreen", "nbSlopesBlue", "nbSlopesRed", "nbSlopesBlack", "domainName", "content"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})